export default {
  namespaced: true,
  state: {
    offset: 1,
    detailsOffset: 1,
    videoList: []
  },
  getters: {

  },
  mutations: {
    SET_STATE (state, payload = {}) {
      const keys = Object.keys(payload)
      keys.forEach(key => state[key] = payload[key])
    }
  },
  actions: {

  },
}
